import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ROUTE_LOGIN, ROUTE_LOGOUT } from '../../shared/consts/routes.const';

const routes: Routes = [
  { path: ROUTE_LOGIN, component: LoginComponent },
  { path: ROUTE_LOGOUT, component: LogoutComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
